var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-aside",
    { class: _vm.toggle(_vm.isCollapse), attrs: { width: "none" } },
    [
      _c("p", { staticClass: "toggle" }, [
        _c("a", {
          staticClass: "toggle",
          class: _vm.toggle(_vm.isCollapse),
          on: {
            click: function ($event) {
              _vm.isCollapse = _vm.isCollapse == true ? false : true
            },
          },
        }),
      ]),
      _c("p", { staticClass: "cuona-logo", class: _vm.toggle(_vm.isCollapse) }),
      _c("p", {
        staticClass: "cuona-nolabel-logo",
        class: _vm.toggle(_vm.isCollapse),
      }),
      _c(
        "el-menu",
        {
          staticStyle: { width: "auto" },
          attrs: { collapse: _vm.isCollapse, "default-openeds": ["1", "2"] },
        },
        [
          _vm._l(_vm.menus, function (menu, i) {
            return [
              _vm.matchMenuAndRole(i) && menu.submenus.length === 0
                ? _c(
                    "el-menu-item",
                    {
                      directives: [
                        {
                          name: "intro",
                          rawName: "v-intro",
                          value: _vm.$t(menu.intro),
                          expression: "$t(menu.intro)",
                        },
                        {
                          name: "intro-highlight-class",
                          rawName: "v-intro-highlight-class",
                          value: "highlightBg",
                          expression: "'highlightBg'",
                        },
                        {
                          name: "intro-disable-interaction",
                          rawName: "v-intro-disable-interaction",
                          value: false,
                          expression: "false",
                        },
                      ],
                      staticStyle: { "padding-left": "0px" },
                      attrs: { index: String(i) },
                    },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { path: menu.path } } },
                        [
                          _c("i", {
                            staticClass: "menu-icon",
                            class: menu.name,
                          }),
                          _c("span", [_vm._v(_vm._s(_vm.$t(menu.title)))]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm.matchMenuAndRole(i)
                ? _c(
                    "el-submenu",
                    {
                      directives: [
                        {
                          name: "intro",
                          rawName: "v-intro",
                          value: _vm.$t(menu.intro),
                          expression: "$t(menu.intro)",
                        },
                        {
                          name: "intro-highlight-class",
                          rawName: "v-intro-highlight-class",
                          value: "highlightBg",
                          expression: "'highlightBg'",
                        },
                        {
                          name: "intro-disable-interaction",
                          rawName: "v-intro-disable-interaction",
                          value: false,
                          expression: "false",
                        },
                      ],
                      attrs: { index: String(i) },
                    },
                    [
                      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                        _c("i", { staticClass: "menu-icon", class: menu.name }),
                        _c("span", [_vm._v(_vm._s(_vm.$t(menu.title)))]),
                      ]),
                      _vm._l(menu.submenus, function (submenu, j) {
                        return _c(
                          "el-menu-item",
                          { key: j, attrs: { index: i + "-" + j } },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: { path: submenu.path } },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.resetAnalysisFilters(
                                      submenu.path
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t(submenu.title)))]
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }